import { RequestOrganizationViewModel } from "../types/types";
import { requestOrganizationEmpty } from "../types/empties";
import { deepClone } from "../utils/objects";

export const getEmptyRequestOrganizationViewModel = (): RequestOrganizationViewModel => {
  const requestOrganizationEmptyClone: RequestOrganizationViewModel =
    deepClone(requestOrganizationEmpty);
  return requestOrganizationEmptyClone;
};
